module.exports = __webpack_public_path__ + "img/cert24.3a3abf22.png";